export const RESERVED_FIELDS = ['Nombre', 'Apellido', 'Correo', 'E-mail'];

const WORD_TERMS = ['nombre', 'apellido', 'correo'];
const SUBSTRING_TERMS = ['e mail', 'email'];

export function normalizeFieldName(name) {
  if (!name) return '';
  const map = {
    á: 'a',
    à: 'a',
    ä: 'a',
    ã: 'a',
    é: 'e',
    è: 'e',
    ë: 'e',
    í: 'i',
    ì: 'i',
    ï: 'i',
    ó: 'o',
    ò: 'o',
    ö: 'o',
    ú: 'u',
    ù: 'u',
    ü: 'u',
    ñ: 'n',
  };
  const joinedKeys = Object.keys(map).map((key) => key).join('');
  const regex = new RegExp(`[${joinedKeys}]`, 'gi');
  return name
    .trim()
    .toLowerCase()
    .replace(regex, (match) => map[match] || match)
    .replace(/[\s_\-]+/g, ' ')
    .trim();
}

export function findReservedTerm(name) {
  const normalized = normalizeFieldName(name);
  if (!normalized) return null;
  const words = normalized.split(' ').filter(Boolean);
  for (const word of words) {
    const idx = WORD_TERMS.indexOf(word);
    if (idx >= 0) return RESERVED_FIELDS[idx];
  }
  for (const term of SUBSTRING_TERMS) {
    if (normalized.includes(term)) return RESERVED_FIELDS[3];
  }
  return null;
}

export function isReservedName(name) {
  return findReservedTerm(name) !== null;
}
